import { render } from "./ProjectShifts.vue?vue&type=template&id=5c0df79d&scoped=true&ts=true"
import script from "./ProjectShifts.ts?vue&type=script&lang=ts"
export * from "./ProjectShifts.ts?vue&type=script&lang=ts"

import "./ProjectShifts.vue?vue&type=style&index=0&id=5c0df79d&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0df79d"]])

export default __exports__